import { render, staticRenderFns } from "./TransferAccount.vue?vue&type=template&id=f90cfb7c&scoped=true"
import script from "./TransferAccount.vue?vue&type=script&lang=js"
export * from "./TransferAccount.vue?vue&type=script&lang=js"
import style0 from "./TransferAccount.vue?vue&type=style&index=0&id=f90cfb7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90cfb7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f90cfb7c')) {
      api.createRecord('f90cfb7c', component.options)
    } else {
      api.reload('f90cfb7c', component.options)
    }
    module.hot.accept("./TransferAccount.vue?vue&type=template&id=f90cfb7c&scoped=true", function () {
      api.rerender('f90cfb7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/TransferAccount.vue"
export default component.exports